import React, { useState, useEffect, useRef } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import {
  createRepository,
  uploadMultipleFiles,
} from '../../redux/slices/apiSlice'
import UseToast from '../../hooks/useToast'
import { RxCaretDown, RxCaretUp, RxCross2 } from 'react-icons/rx'
import fileIcon from '../../assets/images/file.png'
import { FILE_TYPES, FILE_SIZE } from '../../utils'
import Loader from '../../utils/Loader'
import { useSelector } from 'react-redux'
import Chip from '../../utils/Chip'
import moment from "moment";
import Select from "react-select";


const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const UploadMultipleFiles = ({
  onClose,
  currentParentId,
  fetchFolders,
  openUploadMultipleBtnDialog,
}) => {
  const { uploadMultipleLoading } = useSelector((state) => state.api)
  const formikRef = useRef(null)
  const [initialValues, setInitialValues] = useState({
    uploadedFiles: [],
    tags: '',
    yearlyTags: { label: moment().year(), value: moment().year() },
  })
  const [showMonths, setShowMonths] = useState(false)
  const [selectedMonth, setSelectedMonth] = useState([])

  const handleChipClick = (month, setFieldValue) => {
    setSelectedMonth(month);
    setFieldValue("tags", [month]); // Ensure only one month is selected
  };

  const handleChipRemove = (month, setFieldValue) => {
    if (selectedMonth === month) {
      setSelectedMonth(null);
      setFieldValue("tags", []);
    }
  };
  const validationSchema = Yup.object().shape({
    // uploadedFiles: Yup.array()
    //   .min(1, "At least one file is required")
    //   .required("Files are required"),
    uploadedFiles: Yup.array()
      .min(1, 'At least one file is required')
      .test(
        'fileType',
        'Invalid file type. Please upload a supported file format.',
        (files) => {
          if (!files || files.length === 0) return false
          return files.every((file) => [...FILE_TYPES.DOC_TYPES, ...FILE_TYPES.IMAGE_TYPES, ...FILE_TYPES.VIDEO_TYPES].includes(file.type))
        }
      )
      .test("fileSize", function (files) {
        if (!files || files.length === 0) return false;
        for (const file of files) {
          const fileTypeCategory = file.type.startsWith("image/")
            ? "IMAGE_MAX_SIZE"
            : file.type.startsWith("video/")
              ? "VIDEO_MAX_SIZE"
              : "DOC_MAX_SIZE";
          const maxSize = FILE_SIZE[fileTypeCategory];
          const maxSizeMB = (maxSize / (1024 * 1024)).toFixed(2);
          if (file.size > maxSize) {
            return this.createError({
              message: `File "${file.name}" exceeds the allowed limit of ${maxSizeMB} MB.`,
            });
          }
        }
        return true;
      }),
    tags: Yup.array().max(1, 'Please select one Tag').required("Tag is required"),
    yearlyTags: Yup.object().required("Yearly tag is required"),
  })

  const dispatch = useDispatch()
  const { successToast, errorToast } = UseToast()

  const user = JSON.parse(sessionStorage.getItem('user'))
  useEffect(() => {
    setInitialValues((prev) => ({ ...prev, uploadedFiles: [], tags: [], yearlyTags: { label: moment().year(), value: moment().year() } }))
    setSelectedMonth([])
    setShowMonths(false)
    if (formikRef.current) {
      formikRef.current.resetForm()
    }
  }, [openUploadMultipleBtnDialog])
  const token = sessionStorage.getItem('token')

  const handleFileChange = (e, setFieldValue, values) => {
    const selectedFiles = Array.from(e.target.files);
    const processedFiles = selectedFiles.map((file) => {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (fileExtension === 'psd' && !file.type) {
        return new File([file], file.name, { type: 'application/x-photoshop' });
      }
      return file;
    });
    setFieldValue('uploadedFiles', [
      ...values.uploadedFiles,
      ...processedFiles,
    ])
  };


  return (
    <>
      {uploadMultipleLoading ? <Loader></Loader> : <></>}
      <Formik
        initialValues={initialValues}
        innerRef={formikRef}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          try {
            const headers = {
              accept: 'application/json',
              authorization: token,
            }
            const formData = new FormData()
            values.uploadedFiles.forEach((file, index) => {
              formData.append(`uploadedFile`, file)
            })
            formData.append('type', 'file')
            formData.append('owner_id', user._id)
            formData.append('parent_id', currentParentId)
            formData.append('tags', values.tags)
            formData.append('yearlyTags', values.yearlyTags?.value || moment().year())

            let response = await dispatch(
              uploadMultipleFiles({ payload: formData, headers })
            )
            if (response?.payload?.message) {
              successToast('Files uploaded successfully.')
            }
            fetchFolders(currentParentId)
            onClose()
            // }
            resetForm()
          } catch (error) {
            console.error('Upload error:', error)
            errorToast('Failed to upload files.')
          }
        }}
      >
        {({ values, setFieldValue }) => (
          <Form className='bg-white '>

            <div className='bg-blue-100 p-4 overflow-y-auto max-h-[250px] rounded-md relative'>
              <p className='font-bold mb-5'>Primary Files</p>
              <div className='flex flex-wrap items-center justify-around gap-2 mb-5'>
                {values.uploadedFiles.map((file, index) => {
                  const isImage = file.type.startsWith('image')
                  return (
                    <div key={index} className='relative  w-20 h-20 mb-12'>
                      <img
                        src={isImage ? URL.createObjectURL(file) : fileIcon}
                        alt={file.name}
                        className='w-full h-full rounded-md object-cover'
                      />
                      <p
                        className='mt-1 text-xs text-center truncate w-16'
                        title={file.name}
                      >
                        {file.name}
                      </p>
                      <p
                        className='mt-1 text-xs text-center truncate w-16'
                        title={file.name}
                      >
                        {`${file.size ? (file.size / (1024 * 1024)).toFixed(2) : 0
                          } MB`}
                      </p>
                      <button
                        type='button'
                        className='absolute -top-2 -right-2 bg-white rounded-full p-1 shadow'
                        onClick={() => {
                          const updatedFiles = values.uploadedFiles.filter(
                            (_, i) => i !== index
                          )
                          setFieldValue('uploadedFiles', updatedFiles)
                        }}
                      >
                        <RxCross2 className='text-red-500' />
                      </button>
                    </div>
                  )
                })}
              </div>
              <label
                htmlFor='uploadFiles'
                className='uploadFileLbl'
              >
                + Add File
              </label>
              <input
                type='file'
                id='uploadFiles'
                accept='image/*, video/*, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .psd'
                multiple
                className='hidden'
                onClick={(event) => {
                  event.target.value = null;
                }}
                onChange={(e) => handleFileChange(e, setFieldValue, values)}
              />
            </div>
            <ErrorMessage
              name='uploadedFiles'
              component='div'
              className='text-red-500 text-sm mt-1'
            />

            <div className='form-group'>
              <label>Yearly Tags</label>
              <Select
                options={[
                  { label: "2024", value: "2024" },
                  { label: "2025", value: "2025" },
                  { label: "2026", value: "2026" },
                ]}
                className='customSelectBox'
                placeholder="Yearly Tags"
                onChange={(option) =>
                  setFieldValue("yearlyTags", option)
                }
                value={values.yearlyTags}
              />
              <ErrorMessage
                name='yearlyTags'
                component='div'
                className='error-message'
              />
            </div>

            <div className='form-group'>
              <label>Tags</label>
              <div className='min-h-[40px] max-h-[100px] overflow-y-auto border border-gray-300 rounded-md p-2 flex flex-wrap gap-2'>
                {selectedMonth && selectedMonth.length > 0 ? (
                  <Chip
                    label={selectedMonth}
                    onClick={() => console.log('static chip')}
                    onRemove={() =>
                      handleChipRemove(selectedMonth, setFieldValue)
                    }
                  />
                ) : (
                  <span className='text-gray-400'>Select a tag...</span>
                )}
              </div>
              <ErrorMessage
                name='tags'
                component='div'
                className='error-message'
              />
              <div className='relative'>
                <button
                  type='button'
                  className='!mt-2 bg-white flex gap-2 items-center hover:bg-blue-50 text-gray-600 font-semibold text-xs py-1 px-2 border border-gray-300 rounded-full '
                  onClick={() => setShowMonths(!showMonths)}
                >
                  <span>Months</span>
                  <span className='text-blue-400 text-base'>
                    {showMonths ? <RxCaretUp /> : <RxCaretDown />}
                  </span>
                </button>

                <div
                  className={`flex flex-wrap gap-2 mt-1 cursor-pointer bg-white  rounded-md py-2 transition-all duration-700 ease-in-out overflow-hidden transform origin-top ${showMonths
                    ? 'max-h-40 scale-y-100 opacity-100'
                    : 'max-h-0 scale-y-0 opacity-0'
                    }`}
                >
                  {months.map((month, index) => (
                    <Chip
                      key={index}
                      label={month}
                      onClick={() => handleChipClick(month, setFieldValue)}
                    />
                  ))}
                </div>
              </div>
            </div>
            <button
              type='submit'
              className='w-[100px] mt-4 bg-blue-500 text-white py-2 rounded-md'
            >
              Upload
            </button>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default UploadMultipleFiles
